var map = {
	"./11.jpg": 12974,
	"./16.jpg": 32896,
	"./3.jpg": 99983,
	"./4.jpg": 22823,
	"./7.jpg": 96788,
	"./Teams/Atlas.png": 27037,
	"./Teams/Club-puebla.png": 83679,
	"./Teams/Club_Tijuana.png": 35401,
	"./Teams/Santos6estrellas.png": 63247,
	"./Teams/club-america.png": 82862,
	"./Teams/necaxa.png": 74211,
	"./Teams/tigres.png": 80704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74566;